<template>
    <div
        v-if="isCategoryLeaf"
        class="my-1 flex"
    >
        <!-- Remove category -->
        <base-button-icon
            v-if="canRemoveCategory"
            class="mr-2"
            color-type="secondary"
            icon="times"
            size-icon="sm"
            @click.native="$emit('update-category', null, index)"
        ></base-button-icon>
        <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
            <base-button-light color-type="secondary">{{ category.name }}</base-button-light>
        </div>
    </div>
    <!-- Else show a list of choice of category -->
    <div v-else>
        <div>
            <div
                v-if="category !== null"
                class="flex justify-start"
            >
                <base-button-icon
                    color-type="secondary"
                    icon="angle-double-left"
                    @click.native="$emit('update-category', null, index)"
                ></base-button-icon>
            </div>
            <div class="flex flex-row flex-wrap py-2">
                <div
                    v-for="(cat, key) of categories"
                    :key="key"
                    :class="[classSize]"
                    class="w-full p-1"
                >
                    <base-button-light
                        :class="[category === null ? 'justify-end' : 'justify-center h-full']"
                        :icon="(cat.parent === undefined && categoriesIcons[cat.name.toUpperCase()] !== undefined) ? categoriesIcons[cat.name.toUpperCase()] : ''"
                        color-type="secondary"
                        @click.native="$emit('update-category', cat, index)"
                    >
                        <span class="m-auto">{{ cat.name }}</span>
                    </base-button-light>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isEmpty } from '../lib/validator/helpers'

export default {
  name: 'ChooseCategory',
  props: {
    categories: {
      type: Array,
      required: true
    },

    category: {
      type: Object,
      default: null
    },

    index: {
      type: Number,
      required: true
    },

    canRemoveCategory: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: 'lg',
      validator (value) {
        return ['lg', 'sm'].includes(value)
      }
    }
  },

  emits: ['update-category'],
  data () {
    return {
      categoriesIcons: {
        ALARME: 'alarm-clock',
        CARILLON: 'bell',
        DÉTECTEUR: 'sensor-fire',
        INTERPHONE: 'intercom',
        'STATION MÉTÉO': 'cloud-sun',
        BRICOLAGE: 'user-hard-hat',
        DOMOTIQUE: 'laptop-house',
        NETTOYAGE: 'soap',
        'MATERIEL D\'ATELIER': 'tools',
        'ELECTRO-PORTABLE': 'plug',
        'TRAITEMENT DE L\'AIR': 'air-conditioner',
        ECLAIRAGE: 'light-ceiling',
        BRUN: 'tv',
        'HIFI-SON': 'speakers',
        NOMADE: 'tablet',
        ANTENNE: 'broadcast-tower',
        'PHOTO-VIDEO': 'photo-video',
        'LECTEUR/ENREGISTREUR': 'save',
        'CONSOLE DE JEUX': 'gamepad',
        'HOME CINEMA': 'camera-movie',
        IMAGE: 'image',
        PEM: 'bolt',
        'ASPI - NETTOYEUR': 'vacuum',
        'SOIN DU CORPS': 'hand-holding-medical',
        'PREP. CULINAIRE': 'hat-chef',
        CUISSON: 'fire',
        BOISSON: 'glass',
        'SOIN DU LINGE': 'washer',
        'RASAGE-EPILATION': 'cut',
        'SOIN DU CHEVEU': 'head-side',
        VENTILATION: 'fan-table',
        'COUPE BORDURE': 'tools',
        JARDIN: 'flower-tulip',
        FROID: 'snowflake',
        LAVAGE: 'soap',
        ECRAN: 'desktop',
        ORDINATEUR: 'laptop',
        ACCESSOIRES: 'tools',
        MULTIMEDIA: 'tablet-android-alt',
        TELEPHONIE: 'phone',
        'CLIM-CHAUFFAGE': 'fireplace',
        GEM: 'washer',
        MEUBLES: 'couch',
        PACKS: 'box-full',
        SANITAIRES: 'toilet',
        LITERIE: 'bed-empty',
        LOISIR: 'hiking',
        'PETIT DEJEUNER': 'croissant',
        ARROSAGE: 'faucet-drip',
        TRONCONNEUSE: 'cut',
        BUREAUTIQUE: 'desktop',
        COPIEUR: 'copy',
        IMPRIMANTE: 'print',
        PERIPHERIQUE: 'mouse-alt',
        CLIMATISEUR: 'fan-table',
        CHAUFFAGE: 'sensor-fire',
        SOLS: 'vacuum',
        CUISINE: 'hat-chef',
        DIVERS: 'laptop-house',
        DRESSING: 'tshirt',
        'ELECTRICITE GENERALE': 'plug',
        EVIERS: 'sink',
        ROBINETTERIE: 'faucet-drip',
        'SALLE DE BAIN': 'bath',
        'VITRERIE SERRURERIE': 'lock-open'
      }
    }
  },

  computed: {
    isCategoryLeaf () {
      return !isEmpty(this.category?.parent) || this.category?.is_leaf
    },

    classSize () {
      return this.size === 'lg' ? 'md:w-1/2 lg:w-1/3 xl:w-1/4' : 'lg:w-1/2 xl:w-1/3'
    }
  }
}
</script>

<style scoped>

</style>
